import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import Popover from "react-popover";
import Select, { components } from "react-select";
import CreatableSelect from "react-select/creatable";
import swal from "sweetalert";
import { QrReader } from "react-qr-reader";
// <===

// Stylsheet Imports ===>
import "./patientForm.scss";
// <===

// Component Imports ===>
import CustomeDatePicker from "../CustomeDatePicker";
import SearchPatientComponent from "../SearchPatientComponent";
import { WhatsAppContainer } from "../WhatsAppContainer";
import DatePickerNew from "../AgePicker";
import MultipleFileSelector from "../../UI Component/MultipleImageSelector/MultipleFileSelector";
import PatientAbhaVerification from "../PatientAbhaVerification";
import Loader from "../../UI Component/Loader/Loader";
import SecondaryButton from "../../common/Buttons/SecondaryButton";
import PrimaryButton from "../../common/Buttons/PrimaryButton";
// <===

// Icon Imports ===>
import backArrow from "../../../assets/back_arrow_gray.svg";
import errorIcon from "../../../assets/red_close.png";
import qrCodeBig from "../../../assets/qr_code_big.svg";
import qrCodeSmall from "../../../assets/qr_code_small.svg";
import Info from "../../../assets/info.png";
import abhaAdhaarIcon from "../../../assets/AbhaAdhaarVerification.svg";
// <===

// Constant Imports ===>
import {
  BOOK_RESOURCE_APPOINTMENT,
  CLINIC_BOOK_ADD_DETAILS,
  CREATE_NEW_ABHA_PATIENT,
  DOCTOR_INCLINIC_ADD,
  GET_CITY,
  GET_DOCTORS,
  GET_LEAD_PATIENT_DETAILS,
  PUBLIC_BOOK_ADD_DETAILS,
  UPDATE_PATIENT_DETAILS,
  UPLOAD_DOCUMENTS,
} from "../APIHandler/apiConstants";
import {
  getUHIDFormatError,
  UHID_DUPLICATE_ERROR,
  UHID_SINGLE_QUOTES_ERROR,
  EMAIL_REGEX,
  PINCODE_REGEX,
  STATE_LIST,
  customStyles,
  reationStyles,
} from "../Constants";
// <===

// Api handlers ===>
import { getSignedUrl } from "../../../Util/API Calls/SignedAPIUrl";
import {
  c2cGetApiHandler,
  c2cPostApiHandler,
} from "../../../Util/c2cApiHandler";
// <===

// Util Imports ===>
import { DEV, PROD, QA } from "../../common/config";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
// import AbhaDataConfirmation from "../AbhaDataConfirmation/AbhaDataConfirm";
// <===

const PatientForm = ({
  appointmentType,
  abhaPatientDetails,
  doctorData,
  relationList,
  selectedDate,
  selectedSlot,
  followUpVal,
  selectedSlotObj,
  hasResourceAccess,
  addBooking,
  selectedBookingType,
  selectedProcedureList,
  orderId,
  handelProcedureAppointmentId,
  handleAppointIDDEtails,
  existingPatientDetails,
  patientDetails,
  getPatientAccountId,
  isAddNewAbhaPatient,
  showAbhaConfirmationPopup,
  handleCloseAbhaConfirmationContent,
  selectedResource,
  isAbhaTokenBooking,
  showPremiumSlotSelection,
  allotedPremiumSlot,
  selectedResourceProcedure,
  apiSelectedConsultation,
  setPatientDetails,
  setRelationList,
  patientAccountId,
  noDob,
  referredBy,
  errors,
  newDate,
  selectedValue,
  removePatientName,
  isAbhaDetails,
  patientNameSelect,
  selectedPatientValue,
  patientList,
  successfulUploads,
  doctorList,
  enableWhatsaapNotification,
  allowNotifications,
  allowSmsNotification,
  referrelList,
  age,
  patientNumber,
  verifyAbhaAddress,
  selectedRelationValue,
  showTopMargin,
  whatsAppNumber,
  whatsappMessageEnable,
  hfrId,
  uhidPrefix,
  uhIdList,
  isUHidEnabled,
  isInvalidUHID,
  showName,
  newPatient,
  showGuardianDetails,
  relationCode,
  stateCity,
  pincodeError,
  selectedGuardianValue,
  relationName,
  address,
  email,
  pinCode,
  d_year,
  d_month,
  d_day,
  disableAge,
  showAbhaError,
  abhaAddress,
  showAbhaAddress,
  disableAbha,
  dropdownSelectedDate,
  invalidQrCode,
  qrCodedata,
  selectedState,
  referrelName,
  uploadedDocs,
  tempPatientDetails,
  abhaNumber,
  setAbhaNumber,
  setTempPatientDetails,
  setUploadedDocs,
  setReferrelName,
  setSelectedState,
  setQrCodeData,
  setInvalidQrCode,
  setDropdownSelectedDate,
  setDisableAbha,
  setShowAbhaAddress,
  setAbhaAddress,
  setShowAbhaError,
  setDisableAge,
  setDday,
  setDmonth,
  setDyear,
  setPinCode,
  setEmail,
  setAddress,
  setRelationName,
  setSelectedGuardianValue,
  setPincodeError,
  setStateCity,
  setRelationCode,
  setShowGuardianDetails,
  setNewPatient,
  setShowName,
  setIsInvalidUHID,
  setIsUHidEnabled,
  setUHIdList,
  setUHIdPrefix,
  setHfrId,
  setWhatsappMessageEnable,
  setWhatsAppNumber,
  setShowTopMargin,
  setSelectedRelationValue,
  setVerifyAbhaAddress,
  setPatientNumber,
  setAge,
  setReferrelList,
  setAllowSmsNotification,
  setAllowNotifications,
  setEnableWhatsaapNotification,
  setDoctorList,
  setSuccessfulUploads,
  setPatientList,
  setSelectedPatientValue,
  setPatientNameSelect,
  setIsAbhaDetails,
  setRemovePatientName,
  setSelectedValue,
  setNewDate,
  setErrors,
  setReferredBy,
  setNoDob,
  setPatientAccountId,
  isLeadBooking,
  appointmentData,
  retainFileState,
  handleFileState,
}) => {
  // constants ===>
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const genderOptions = ["Male", "Female", "Others"];
  const patientDropdownRef = useRef(null);
  const lastResult = useRef(null);
  const emailRef = useRef(null);
  const pinCodeRef = useRef(null);
  const inputRef = useRef(null);

  const [isDocUploaded, setIsDocUploaded] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [patientNameAutoFocus, setPatientNameAutoFocus] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showAbhaScan, setShowAbhaScan] = useState(false);
  const [showAadharAbhaVerification, setShowAadharAbhaVerification] =
    useState(false);

  // <====

  // Lifecycle ===>
  useEffect(() => {
    uploadFilesCallback();
  }, [uploadedDocs]);

  useEffect(() => {
    getPatientAccountId(patientAccountId);
  }, [patientAccountId]);

  useEffect(() => {
    afterLoginApiAxios
      .post(
        "/public/get-patient-relation-list",
        {
          "authorizer-principal-id": {
            user_type: "1",
            user_id: userId,
          },
          user_id: userId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        if (
          response?.data?.statusCode == 200 &&
          response?.data &&
          response?.data.patient_relations_list?.length > 0
        ) {
          let arr = [
            {
              value: "1",
              label: "Select Relation",
            },
          ];
          response.data.patient_relations_list.map((data, index) => {
            let obj = {};
            obj["value"] = data.id;
            obj["label"] = data.relation;
            arr.push(obj);
          });
          setRelationList(arr);
        } else {
          setRelationList([]);
        }
      })
      .catch((err) => C2CConsole.log(err));
  }, []);

  useEffect(() => {
    if (clinicId) {
      let api = "/api/v1/" + clinicId + "/check_patient_uhid";
      const uhIdResponse = c2cGetApiHandler(api);
      uhIdResponse.then(([res, error]) => {
        if (!error) {
          setEnableWhatsaapNotification(
            res.data.enable_whatsapp_notifications.enable_whatsapp_notifications
          );
          setAllowSmsNotification(
            res.data.enable_clinic_sms || res.data.enable_patient_sms
          );
          if (res.data.patient_uhid_enabled) {
            if (res.data.existing_patient_uhids?.length > 0) {
              res.data.existing_patient_uhids.forEach((d) => {
                let word = d.formatted_uhid.match(/\D+/g);
                let digits = d.formatted_uhid.match(/\d+/g);
                d["uhid_prefix"] = word?.length > 0 ? word[0] : "";
                d["uhid_no"] = digits?.length > 0 ? Number(digits[0]) : "";
              });
            }
            setUHIdPrefix(res?.data?.patient_uhid_prefix?.trim());
            setUHIdList(res?.data.existing_patient_uhids);
          } else {
            setUHIdList([]);
          }
          setIsUHidEnabled(res.data.patient_uhid_enabled);
          setHfrId(res?.data?.abdm_hfr_id ? res?.data?.abdm_hfr_id : "");
        }
      });
    } else {
      setAllowSmsNotification(true);
    }

    getDoctorList(clinicId);
  }, []);

  useEffect(() => {
    if (
      hfrId &&
      patientDetails?.patient_gender &&
      patientDetails?.patient_name &&
      patientDetails?.patient_name?.trim()?.length > 0 &&
      patientDetails?.patient_no &&
      patientDetails?.patient_no?.replace("+91", "")?.length === 10
    ) {
      setShowAbhaAddress(true);
    } else {
      setShowAbhaAddress(false);
    }
  }, [hfrId, patientDetails]);

  useEffect(() => {
    if (
      patientDetails?.patient_gender === tempPatientDetails?.patient_gender &&
      patientDetails?.patient_name === tempPatientDetails?.patient_name &&
      tempPatientDetails?.preferred_abha_address
    ) {
      setDisableAbha(
        [true, "True", "true"].includes(
          tempPatientDetails?.abha_address_kyc_verified
        )
      ); //tempPatientDetails?.abha_address_kyc_verified?.toLowerCase() === "true"
      setVerifyAbhaAddress(
        ![true, "True", "true"].includes(
          tempPatientDetails?.abha_address_kyc_verified
        )
      ); // tempPatientDetails?.abha_address_kyc_verified?.toLowerCase() !== "true"
    } else {
      setDisableAbha(false);
      setVerifyAbhaAddress(true);
    }
  }, [tempPatientDetails, patientDetails]);

  useEffect(() => {
    if (isAddNewAbhaPatient && abhaPatientDetails) {
      setLoading(true);
      createNewAbhaPatient();
      setIsAbhaDetails(true);
    } else if (
      !isAddNewAbhaPatient &&
      abhaPatientDetails &&
      existingPatientDetails
    ) {
      handleAutoPopulateDetails(existingPatientDetails);
      setIsAbhaDetails(true);
    }
  }, [isAddNewAbhaPatient, abhaPatientDetails, existingPatientDetails]);

  useEffect(() => {
    if (isLeadBooking) {
      getQuotePatientDetails(appointmentData?.patient_account_id);
    }
  }, [isLeadBooking]);

  // <====

  // API Calls ===>

  const getDoctorList = (id) => {
    if (id == null) return;
    let params = {
      clinic_id: id,
    };
    c2cGetApiHandler(GET_DOCTORS, params)
      .then((res) => {
        res = res[0];
        let arr1 = res.data.doctor_list.map((ele, i) => {
          return {
            label: ele.doctor_name,
            chipLabel: ele.specialization,
            value: i,
            doctor_id: ele.doctor_id,
          };
        });
        let arr2 = res.data.referral_doctors.map((ele, i) => {
          return {
            label: ele.name,
            chipLabel: ele.specialization,
            value: i,
            doctor_id: ele.doctor_id,
          };
        });

        setReferrelList([
          ...arr1,
          ...arr2,
          { label: "Other", value: "Other" },
          { label: "Organization", value: "Organization" },
        ]);
      })
      .catch((error) => {
        C2CConsole.log(error);
      });
  };

  const createNewAbhaPatient = () => {
    let dateFormats = [
      "DD/MM/YYYY",
      "DD-MM-YYYY",
      "YYYY-MM-DD",
      "YYYY/MM/DD",
      "MM/DD/YYYY",
      "MM-DD-YYYY",
    ];
    let qrDob = moment(abhaPatientDetails?.dob, dateFormats).format(
      "YYYY-MM-DD"
    );

    let payload = {
      phone_no: "+91" + abhaPatientDetails?.phone_number,
      patient_name: abhaPatientDetails?.name,
      patient_dob: qrDob,
      clinic_id: clinicId,
      date: moment().format("YYYY-MM-DD"),
      patient_email: "",
      patient_address: abhaPatientDetails?.address,
      preferred_abha_address: abhaPatientDetails?.abha_address,
      patient_gender: abhaPatientDetails?.gender,
      abha_number: abhaPatientDetails?.health_id_number,
    };

    let resData = c2cPostApiHandler(CREATE_NEW_ABHA_PATIENT, payload);
    resData.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        patientDetails.dob = qrDob;
        patientDetails.patient_name = abhaPatientDetails?.name;
        patientDetails.patient_gender = abhaPatientDetails?.gender;
        patientDetails.patient_address = abhaPatientDetails?.address;
        patientDetails.patient_no = abhaPatientDetails?.phone_number;
        patientDetails.patient_account_id = res?.data?.patient_account_id;
        patientDetails.patient_id = res?.data?.patient_id;
        setAbhaAddress(abhaPatientDetails?.abha_address);
        setAbhaNumber(abhaPatientDetails?.ABHANumber);
        setNoDob(false);
        setNewDate(qrDob);
        getAge(qrDob);
        setWhatsAppNumber(abhaPatientDetails?.phone_number);
        setPatientDetails({ ...patientDetails });
        setSelectedValue(true);
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  const getStateCity = (pincode, quotePatientDetails) => {
    let details = quotePatientDetails ? quotePatientDetails : patientDetails;
    let payload = {
      pincode: pincode,
    };
    c2cPostApiHandler(GET_CITY, payload)
      .then((response) => {
        response = response[0];
        if (response.data.statusCode == 200) {
          setPincodeError(false);
          clearErrors("pincode");
          setStateCity(response.data.data);
          details["patient_state_name"] = response.data.data.state_name;
          details["city_name"] = response.data.data.city_name;
          details["patient_pincode"] = pincode;
          details["state_name"] = response.data.data.state_name;

          STATE_LIST.forEach((e) => {
            if (e.label === response.data.data.state_name) {
              setValue("state", {
                label: e.label,
                value: e.value,
              });
              details["patient_state_code"] = e.value;
              setPatientDetails(details);
            }
          });
        } else {
          C2CConsole.log("Error occurred");
          setStateCity(null);
          setPincodeError(true);
          setErrors((prevErrors) => ({
            ...prevErrors,
            pincode: "Please enter valid pincode",
          }));
          details["patient_state_code"] = "";
          details["city_name"] = "";
        }
      })
      .catch((err) => C2CConsole.log(err));
  };

  const uploadDocuments = (appointmentId) => {
    if (appointmentId) {
      let updatedPayload = successfulUploads ? [...successfulUploads] : [];
      updatedPayload.forEach((obj) => {
        obj.appointment_id = appointmentId;
      });
      if (updatedPayload.length > 0) {
        let payload = { appointment_id: appointmentId, docs: updatedPayload };
        c2cPostApiHandler(UPLOAD_DOCUMENTS, payload)
          .then((response) => {
            response = response[0];
            if (response.data.statusCode === 200) {
              C2CConsole.log("FILES UPLOADED SUCCESSFULLY");
            } else {
              C2CConsole.log("ERROR UPLOADING FILES");
            }
          })
          .catch((err) => C2CConsole.log(err));
      }
    }
  };

  const updatePatientDetails = (updatePayLoad) => {
    c2cPostApiHandler(UPDATE_PATIENT_DETAILS, updatePayLoad)
      .then((response) => {
        response = response[0];
        if (response.data) {
          if (response.data.statusCode === 200) {
            C2CConsole.log("success");
          } else {
            // TODO: Error handling and logging
          }
        } else {
          // TODO: Error handling and logging
        }
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  };

  const bookAppointment = (requestPayload) => {
    let url =
      clinicId !== "" && clinicId !== undefined && clinicId !== null
        ? CLINIC_BOOK_ADD_DETAILS
        : PUBLIC_BOOK_ADD_DETAILS;
    c2cPostApiHandler(url, requestPayload)
      .then((response) => {
        response = response[0];
        if (response.data.statusCode == 200) {
          // Add appointment id to the object
          let patient = {}; //patientDetails
          patient.appointment_id = response.data.appointment_id;
          handleAppointIDDEtails(patient);
          setLoading(false);
          uploadDocuments(response.data.appointment_id);
        } else {
          setLoading(false);
          if (response.data.message) {
            swal({
              title: "Error",
              text: response.data.message,
              type: "error",
              icon: "error",
              button: "OK",
            });
            removeData();
          }
          C2CConsole.log("Error occurred");
        }
      })
      .catch((err) => C2CConsole.log(err));
  };

  const addNewPatientApi = (addNewRequestPayload, data) => {
    c2cPostApiHandler(DOCTOR_INCLINIC_ADD, addNewRequestPayload)
      .then((response) => {
        response = response[0];
        if (response.data.statusCode === 200) {
          savePatientDetails(data, response.data.patient_id);
        } else {
          swal({
            title: "Error",
            text: response.data.errorMessage,
            type: "error",
            icon: "error",
            button: "OK",
          });
          setLoading(false);
        }
      })
      .catch((err) => C2CConsole.log(err));
  };

  const getQuotePatientDetails = (patient_id) => {
    let params = {
      patient_id: patient_id,
    };
    const quotePatientDetails = c2cGetApiHandler(
      GET_LEAD_PATIENT_DETAILS,
      params
    );
    quotePatientDetails.then(([res, error]) => {
      if (!error && res?.data?.statusCode === 200) {
        res.data.data["patient_no"] = res?.data?.data?.phone_no?.includes("+91")
          ? res?.data?.data?.phone_no?.split("+91")[1]
          : res?.data?.data?.phone_no;
        getStateCity(res?.data?.data?.patient_pincode, res?.data?.data);
        getSearchedPatient(res?.data?.data, isLeadBooking);
      }
    });
  };

  // <===

  const uploadFiles = async () => {
    let succededFiles = [];
    for (const file of uploadedDocs) {
      let payload = {
        file_size: file.size,
        doc_title: file.name,
        user_type: userType,
        use_case: "book-appointment-add-details_rev1",
        user_id:
          userType === "doctor" ? userId : userType === "staff" && staffId,
        uploader_id: userType === "doctor" ? 1 : userType === "staff" && 4,
      };
      setIsDocUploaded(true);
      let signedUrl = await getSignedUrl(payload, file.fileDate);
      setIsDocUploaded(false);
      if (signedUrl) {
        succededFiles.push({
          document_path: signedUrl.fields["key"],
          document_title: file.name,
          document_size: payload.file_size,
          uploader_source: "web",
          uploader_id: payload.user_id,
          uploader_type: payload.uploader_id,
        });
      }
      if (succededFiles.length == uploadedDocs.length) return succededFiles;
    }
  };

  const handleAutoPopulateDetails = (details) => {
    if (details?.patient_dob) {
      setNoDob(false);
    } else {
      setNoDob(true);
    }
    getStateCity(details?.patient_pincode);
    patientDetails.patient_name = details?.patient_name;
    patientDetails.patient_gender = details?.patient_gender;
    patientDetails.patient_address = details?.patient_address;
    patientDetails.patient_no = details?.phone_no;
    patientDetails.patient_id = details?.patient_id;
    patientDetails.patient_account_id = details?.patient_account_id;
    patientDetails.patient_email = details?.patient_email;
    patientDetails.patient_pincode = details?.patient_pincode;
    patientDetails.dob = details?.patient_dob;
    patientDetails.formatted_uhid = details?.formatted_uhid;
    setAbhaAddress(details?.preferred_abha_address);
    setWhatsAppNumber(details?.phone_no?.replace("+91", ""));
    setNewDate(details?.patient_dob ?? "");
    setPinCode(details?.patient_pincode);
    setPatientDetails({ ...patientDetails });
    setSelectedValue(true);
  };

  const uploadFilesCallback = async () => {
    if (calcTotalFileSize(uploadedDocs) < 50) {
      let upload = await uploadFiles();
      if (upload === undefined && uploadedDocs.length > 0) {
        swal({
          title: "Invalid File type!",
          text: "Please upload file having extensions .jpeg/.jpg/.png/.gif/.pdf/.doc only.",
          type: "error",
          icon: "warning",
        }).then(function () {});
      } else {
        setSuccessfulUploads(upload);
      }
    } else {
      swal({
        title: "File Size Exceeded",
        text: "Uploaded files should be less than 50 Mb",
        type: "error",
        icon: "warning",
      }).then(function () {});
    }
  };

  const getAge = (date) => {
    let startDate = moment(date, "YYYY-MM-DD");
    let endDate = moment();
    const duration = moment.duration(endDate.diff(startDate));
    setDyear(duration.years());
    setDmonth(duration.months());
    setDday(duration.days());
    let patientAge = `${
      duration.years() +
      " years " +
      duration.months() +
      " months " +
      duration.days() +
      " days "
    }`;
    setValue("age", patientAge);
    setValue("dob", date);
    setAge(patientAge);
    clearErrors("age");
  };

  const handleBackArrow = () => {
    if (!invalidQrCode && qrCodedata) {
      handleAbhaScan();
    } else {
      setShowAbhaScan(false);
      setInvalidQrCode(false);
      setQrCodeData("");
    }
  };

  const getSearchedPatient = (selected, isLeadBooking) => {
    setAbhaAddress(selected?.preferred_abha_address);
    setAbhaNumber(selected?.ABHANumber);
    setPatientDetails({
      ...patientDetails,
      patient_no: selected.patient_no,
    });
    setWhatsAppNumber(
      selected?.whatsapp_number
        ? selected?.whatsapp_number?.split("+91")[1]
        : selected?.patient_no
        ? selected?.patient_no?.split("+91")[1]
        : whatsAppNumber
    );

    setWhatsappMessageEnable(
      [true, "True", "true"].includes(selected?.whatsapp_consent)
    );

    setPinCode(selected?.patient_pincode);
    setPatientDetails({
      ...selected,
      note: patientDetails?.note ? patientDetails?.note : "",
      patient_state_name: selected?.patient_state_name,
    });
    if (selected?.patient_state_name) {
      STATE_LIST.forEach((e) => {
        if (e.label === selected?.patient_state_name) {
          setPatientDetails({
            ...selected,
            patient_state_code: e.value,
            state_code: e.value,
          });
        }
      });
    }
    if (selected?.patient_dob) {
      setNewDate(selected.patient_dob);
    }
    setSelectedValue(true);
    setSelectedPatientValue(true);
    if (!isLeadBooking) {
      setPatientNameSelect(true);
    }
    if (selected?.relation || selected?.parent_guardian_name) {
      setSelectedRelationValue(true);
      setSelectedGuardianValue(true);
    }
    if (selected?.patient_dob) {
      setNoDob(false);
    } else {
      setNoDob(true);
    }

    if (selected?.patient_state_name) {
      setSelectedState(false);
    }
    clearErrors();
    setIsInvalidUHID(false);
    setPincodeError(false);
    setTempPatientDetails({ ...selected });
  };

  const validateUhid = (value) => {
    let enteredVal = value;
    let regEx = /^[A-Za-z]+[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{0,1}[0-9]+$/;
    let single_double_quote_regex = /['||"]/;
    let newArr = uhIdList?.length > 0 ? [...uhIdList] : [];
    let selectedPatinetUHID = "";
    if (patientDetails?.patient_account_id) {
      let indx = newArr.findIndex(
        (d) => d.patient_account_id === patientDetails?.patient_account_id
      );
      if (indx > -1) {
        selectedPatinetUHID = newArr[indx].formatted_uhid;
      }
      newArr = newArr.filter(
        (d) => d.patient_account_id !== patientDetails?.patient_account_id
      );
    }
    if (enteredVal.length > 0) {
      if (selectedPatinetUHID === enteredVal) {
        clearErrors("formatted_uhid");
        setIsInvalidUHID(false);
      } else {
        if (single_double_quote_regex.test(enteredVal)) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            formatted_uhid: {
              type: "custom",
              message: UHID_SINGLE_QUOTES_ERROR,
            },
          }));
          setIsInvalidUHID(true);
        } else {
          if (uhidPrefix) {
            if (regEx.test(enteredVal)) {
              let word = value.match(/\D+/g);
              let digits = value.match(/\d+/g);
              if (word.length > 0) {
                if (word[0]?.toLowerCase() === uhidPrefix?.toLowerCase()) {
                  if (digits.length > 0) {
                    if (newArr?.length > 0) {
                      let index = newArr.findIndex(
                        (d) => d.uhid_no === Number(digits[0])
                      );
                      if (index > -1) {
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          formatted_uhid: {
                            type: "custom",
                            message: UHID_DUPLICATE_ERROR,
                          },
                        }));
                        setIsInvalidUHID(true);
                      } else {
                        clearErrors("formatted_uhid");
                        setIsInvalidUHID(false);
                      }
                    } else {
                      clearErrors("formatted_uhid");
                      setIsInvalidUHID(false);
                    }
                  }
                } else {
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    formatted_uhid: {
                      type: "custom",
                      message: getUHIDFormatError(uhidPrefix),
                    },
                  }));
                  setIsInvalidUHID(true);
                }
              }
            } else {
              setErrors((prevErrors) => ({
                ...prevErrors,
                formatted_uhid: {
                  type: "custom",
                  message: getUHIDFormatError(uhidPrefix),
                },
              }));
              setIsInvalidUHID(true);
            }
          } else {
            let duplicateUHID = newArr.filter(
              (existingUHID) =>
                existingUHID?.formatted_uhid?.toLowerCase()?.trim() ===
                enteredVal?.toLowerCase()?.trim()
            );
            if (duplicateUHID?.length > 0) {
              setErrors((prevErrors) => ({
                ...prevErrors,
                formatted_uhid: {
                  type: "custom",
                  message: UHID_DUPLICATE_ERROR,
                },
              }));
              setIsInvalidUHID(true);
            } else {
              clearErrors("formatted_uhid");
              setIsInvalidUHID(false);
            }
          }
        }
      }
    } else {
      clearErrors("formatted_uhid");
      setIsInvalidUHID(false);
    }
  };

  const handleInputChange = (e, val) => {
    setPatientDetails({
      ...patientDetails,
      [e.target.name]: e.target.value,
    });
    if (doctorList.length === 0 && val == "number") {
      setNewPatient(true);
      setShowName(false);
    }

    if (
      e.target.value.length > 9 &&
      (!patientDetails?.patient_name ||
        patientDetails?.patient_name?.trim() === "") &&
      val == "number" &&
      doctorList.length !== 0
    ) {
      setShowName(true);
    }
    if (val === "formatted_uhid") {
      validateUhid(e.target.value);
    }
    if (val === "name") {
      let value = e.target.value;
      if (value.length === 0) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          patient_name: "Please enter patient name.",
        }));
      } else {
        clearErrors("patient_name");
      }
    }
    if (val === "number") {
      let value = e.target.value;
      if (value.length === 10) {
        setWhatsAppNumber(e.target.value);

        setErrors((prevErrors) => ({ ...prevErrors, patient_no: "" }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          patient_no: "Please enter valid number.",
        }));
      }
    }
  };

  const removeData = () => {
    setPatientDetails({
      ...patientDetails,
      patient_account_id: "",
      patient_id: "",
      patient_name: "",
      patient_dob: "",
      patient_email: "",
      patient_gender: "",
      patient_no: "",
      doctor_id: "",
      patient_address: "",
      patient_pincode: "",
      patient_state_code: "",
      patient_state_name: "",
      city_name: "",
      state_name: "",
      patient_relation_id: "",
      relation: "",
      parent_guardian_name: "",
      formatted_uhid: "",
    });

    setStateCity("");
    setShowName(false);
    setPatientList("");
    setDoctorList("");
    setNewDate("");
    setSelectedValue(false);
    setPatientNameSelect(false);
    setSelectedPatientValue(false);
    setNewPatient(false);
    setSelectedRelationValue(false);

    setSelectedGuardianValue(false);
    setShowGuardianDetails(false);
    setNoDob(false);
    clearUHIDError();
    setPinCode("");
    setPincodeError(false);
  };

  function removePatientNameData() {
    let patientsInfo = { ...patientDetails };
    for (let key in patientsInfo) {
      patientsInfo[key] = "";
      if (key === "patient_no") patientsInfo[key] = patientDetails?.patient_no;
    }
    if (doctorList.length !== 0 && patientDetails?.patient_no) {
      setShowName(true);
    } else {
      setShowName(false);
    }
    setStateCity("");
    setAddress("");
    setNewDate("");
    setAge("");
    setValue("age", "");
    setPatientNumber(patientDetails?.patient_no);
    setSelectedValue(false);
    setPatientNameSelect(false);
    setSelectedPatientValue(false);
    setSelectedRelationValue(false);
    setSelectedGuardianValue(false);
    setNoDob(false);
    clearUHIDError();
    setPinCode("");
    setPincodeError(false);
    setPatientDetails(patientsInfo);
  }

  const setValue = (field, value) => {
    setPatientDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const clearErrors = (field) => {
    setErrors((prevErr) => {
      let err = { ...prevErr };
      if (field) {
        err[field] = "";
      } else {
        for (let key in err) {
          err[key] = "";
        }
      }
      return err;
    });
  };

  const handleDisablePatientName = () => {
    setPatientNameSelect(true);
  };
  const maxLengthCheck = (e) => {
    if (e.target.value.length > e.target.maxLength) {
      e.target.value = e.target.value.slice(0, e.target.maxLength);
    }
  };
  const getList = (list, selected, name) => {
    setPatientNameSelect(false);
    let arr = [
      {
        value: "1",
        label: "Select Patient",
      },
    ];

    if (list !== null) {
      list.map((data) => {
        let obj = {};
        obj["value"] = data.patient_id;
        obj["label"] = data.patient_name;
        obj["patient_account_id"] = data.patient_account_id;
        arr.push(obj);
      });

      if (
        patientDetails?.patient_no?.length > 9 &&
        (!patientDetails?.patient_name ||
          patientDetails?.patient_name?.trim() === "") &&
        list.length !== 0 &&
        !selectedValue &&
        !selected
      ) {
        setPatientNameAutoFocus(name !== "formatted_uhid" ? true : false);
        setShowName(true);
      } else {
        setShowName(false);
      }
      setPatientList(arr);
      setDoctorList(list);
    }

    if (
      patientDetails?.patient_no?.length > 9 &&
      name &&
      name !== "formatted_uhid" &&
      !selected
    ) {
      patientDropdownRef.current && patientDropdownRef.current.focus();
    }
  };

  const getUserDOB = (date, errorStatus) => {
    setNoDob(false);
    setDropdownSelectedDate({
      day: date.day,
      month: date?.month,
      year: date?.year?.toString(),
    });
    if (
      date?.year &&
      date?.year?.toString()?.length === 4 &&
      date?.month &&
      date.day
    ) {
      if (errorStatus) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          dob: { message: "Please choose a valid date of birth" },
        }));
        setValue("age", "");
        setAge();
        setDyear("00");
        setDmonth("00");
        setDday("00");
        setNewDate("");
        setDisableAge(true);
      } else {
        clearErrors("dob");
        const newDate = date?.year + "-" + date?.month + "-" + date?.day;
        setNoDob(true);
        setNewDate(newDate);
        setPatientDetails((prev) => ({
          ...prev,
          dob: newDate,
        }));
        getAge(newDate);
        setDisableAge(true);
        setShowAbhaError("");
      }
    } else {
      if (
        (date?.year === "" || date?.year === null) &&
        date?.month === "" &&
        date.day === ""
      ) {
        setNewDate("");
        setDisableAge(false);
        setPatientDetails({
          ...patientDetails,
          dob: "",
        });
        setValue("age", "");
        setAge();
        setDyear("00");
        setDmonth("00");
        setDday("00");
      } else {
        setNewDate("");
        setDisableAge(true);
        setValue("age", "");
        setAge();
        setDyear("00");
        setDmonth("00");
        setDday("00");
      }

      if (abhaAddress) {
        setShowAbhaError("Please Enter Date of Birth.");
      } else {
        setShowAbhaError("");
      }
    }
  };
  const removeUHID = () => {
    setPatientDetails({
      ...patientDetails,
      formatted_uhid: "",
    });
    clearErrors("formatted_uhid");
    setIsInvalidUHID(false);
  };
  const clearUHIDError = () => {
    clearErrors("formatted_uhid");
    setIsInvalidUHID(false);
  };
  const handlePatientSelect = (item) => {
    setPatientAccountId(item.patient_account_id);
    const id = doctorList.filter((obj) => obj.patient_name === item.label);
    setPatientDetails({
      ...patientDetails,
      patient_name: id.length !== 0 ? id[0].patient_name : item.label,
    });
    if (id.length !== 0) {
      getSearchedPatient(id?.[0]);
      id[0]?.patient_dob && setNewDate(id[0]?.patient_dob);
    }
    setPatientNameSelect(false);
    setShowName(false);
  };
  const handleNewPatientName = (val) => {
    setSelectedValue(false);
    if (val.target.value) {
      const id = patientList.filter(
        (obj) => obj.patient_name === val.target.value
      );
      if (id.length === 0) {
        setShowName(false);
        clearErrors("patient_name");
        setPatientDetails({
          ...patientDetails,
          patient_name: val.target.value,
        });
      }
    }
  };
  const handleRelationSelect = (relation) => {
    setShowGuardianDetails(relation.value === "1" ? false : true);
    if (relation.value !== "1") {
      setTimeout(() => {
        if (inputRef) {
          inputRef.current && inputRef.current.focus();
        }
      }, 100);
    }
    setRelationCode(relation?.value);
    setPatientDetails({
      ...patientDetails,
      patient_relation_id: relation.value,
      relation: relation?.label,
    });
  };
  const bookResourceAppointmentAPICall = (requestPayload) => {
    let appointment_details = [];
    let doctorIds = [];
    selectedProcedureList.forEach((data) => {
      if (!doctorIds?.includes(data?.doctor_id)) {
        doctorIds.push(data?.doctor_id);
      }
    });
    doctorIds.forEach((doctor_id) => {
      let filteredList = selectedProcedureList.filter(
        (data) => data?.doctor_id === doctor_id
      );
      if (selectedProcedureList?.length > 0) {
        if (filteredList[0].common_procedure) {
          let procIds = [];
          filteredList.forEach((data) => procIds.push(data?.id));
          let obj = {
            appointment_slot_id:
              hasResourceAccess || addBooking
                ? filteredList[0]?.custom_slot
                  ? filteredList[0]["alloted_custom_slot"]["slot_id"]
                  : filteredList[0].appointment_slot_id
                : allotedPremiumSlot?.slot_id,
            appointment_date: filteredList[0]?.appointment_date || selectedDate,
            is_premium_slot:
              hasResourceAccess || addBooking
                ? filteredList[0]?.custom_slot
                : allotedPremiumSlot?.start_time &&
                  allotedPremiumSlot?.end_time,
            doctor_id: filteredList[0]?.doctor_id,
            is_walkin: filteredList[0]?.is_walkin,
            common_procedure: true,
            procedure_ids: procIds,
            start_time: filteredList[0]?.alloted_custom_slot?.startTime
              ? moment(
                  filteredList[0]?.alloted_custom_slot?.startTime,
                  "hh:mm A"
                ).format("HH:mm:ssZ")
              : null,
            end_time: filteredList[0]?.alloted_custom_slot?.endTime
              ? moment(
                  filteredList[0]?.alloted_custom_slot?.endTime,
                  "hh:mm A"
                ).format("HH:mm:ssZ")
              : null,
          };
          appointment_details.push(obj);
        } else {
          filteredList.forEach((item) => {
            let obj = {
              appointment_slot_id:
                hasResourceAccess || addBooking
                  ? item?.custom_slot
                    ? item?.alloted_custom_slot?.slot_id
                    : item?.appointment_slot_id
                  : allotedPremiumSlot?.slot_id,
              appointment_date: item?.appointment_date || selectedDate,
              is_premium_slot:
                hasResourceAccess || addBooking
                  ? item?.custom_slot
                  : allotedPremiumSlot?.["start_time"] &&
                    allotedPremiumSlot?.["end_time"],
              doctor_id: item?.doctor_id,
              is_walkin: item?.is_walkin,
              common_procedure: false,
              procedure_ids: [item?.id],
              start_time: item?.alloted_custom_slot?.startTime
                ? moment(
                    item?.alloted_custom_slot?.startTime,
                    "hh:mm A"
                  ).format("HH:mm:ssZ")
                : null,
              end_time: item?.alloted_custom_slot?.endTime
                ? moment(item?.alloted_custom_slot?.endTime, "hh:mm A").format(
                    "HH:mm:ssZ"
                  )
                : null,
            };
            appointment_details.push(obj);
          });
        }
      }
    });

    let payload = {
      ...requestPayload,
      order_id: orderId,
      appointment_details: appointment_details,
      "authorizer-principal-id": {
        user_type: userType === "staff" ? "4" : "1",
        user_id: userType === "staff" ? staffId : userId,
        agent: "Web",
      },
    };
    const bookingResponse = c2cPostApiHandler(
      BOOK_RESOURCE_APPOINTMENT,
      payload
    );
    bookingResponse.then(([res, err]) => {
      if (!err && res?.data?.statusCode === 200) {
        const appointmentId = res?.data?.appointment_id;
        handelProcedureAppointmentId(appointmentId);
        // Add appointment id to the object
        let patient = {}; //patientDetails
        patient.appointment_id = res.data.appointment_id;
        handleAppointIDDEtails(patient);
        setLoading(false);
        uploadDocuments(res.data.appointment_id);
      } else {
        setLoading(false);
        if (res.data.message) {
          swal({
            title: "Error",
            text: res.data.message,
            type: "error",
            icon: "error",
            button: "OK",
          });
          removeData();
        }
        C2CConsole.log("Error occurred");
      }
    });
  };

  const getAbhaGender = (val) => {
    switch (val) {
      case "F":
        return "Female";
      case "M":
        return "Male";
      default:
        return "Others";
    }
  };

  function savePatientDetails(data, patientID) {
    let doctor_Id = "";
    if ((addBooking && isAbhaTokenBooking) || isLeadBooking) {
      //added to send the proper doctor id in case of abha token booking
      doctor_Id = selectedResource?.doctor_id
        ? selectedResource?.doctor_id
        : userId;
    } else {
      doctor_Id =
        doctorData && doctorData?.doctor_id ? doctorData?.doctor_id : userId;
    }
    //patient_id
    setLoading(true);
    let requestPayload = {
      patient_id: data.patient_id ? data.patient_id : patientID,
      consultation_book_method:
        appointmentType == "online" ? "online-from-clinic" : appointmentType,
      appointment_date: selectedDate,
      appointment_slot_id: showPremiumSlotSelection
        ? allotedPremiumSlot?.slot_id
        : selectedSlot,
      is_premium_slot: showPremiumSlotSelection,
      dob: data.dob
        ? moment(data.dob).format("YYYY-MM-DD")
        : newDate != ""
        ? moment(newDate).format("YYYY-MM-DD")
        : "",
      email: data.patient_email ? data.patient_email : "",
      gender: data.patient_gender,
      is_follow_up: followUpVal,
      name:
        data?.patient_name[0].toUpperCase() +
        data?.patient_name.slice(1).toLowerCase(),
      patient_address: data.patient_address ? data.patient_address : "",
      patient_pincode: data.patient_pincode
        ? data.patient_pincode
        : data.pincode,
      phone_number: data?.patient_no?.includes("+91")
        ? data?.patient_no?.split("+91")[1]
        : data?.patient_no
        ? data?.patient_no
        : patientNumber, //data.mobileNumber,
      purpose_of_appointment: data.note ? data.note : "",
      registration_type: 0, // TODO: pass correct value
      state_code: data.patient_state_code, // TODO: Pass correct value
      // doctor_id: doctor_Id,
      age: age,
      new_patient: data?.patient_account_id ? "False" : "True",
      patient_account_id: data.patient_account_id
        ? data.patient_account_id
        : "",
      formatted_uhid: data?.formatted_uhid?.toUpperCase(),
      referred_by: referredBy ? referredBy?.label : "",
      referred_id: referredBy ? referredBy?.doctor_id : "",
      referred_name: referrelName ? referrelName : "",
      whatsapp_consent: whatsappMessageEnable ? "True" : "False",
      whatsapp_number: whatsAppNumber,
      allow_notifications: allowNotifications,
      // docs: successfulUploads,
      preferred_abha_address: abhaAddress,
    };
    if (isLeadBooking) {
      requestPayload["source_lead_id"] = appointmentData?.id;
    }
    if (localStorage.getItem("user_type") === "staff") {
      requestPayload.staff_id = staffId;
    }
    if (showGuardianDetails) {
      requestPayload["patient_relation_id"] = relationCode;
      requestPayload["parent_guardian_name"] = relationName;
    }
    if (clinicId !== "" && clinicId !== undefined && clinicId !== null) {
      requestPayload["clinic_id"] = clinicId;
      requestPayload["abdm_hfr_id"] = hfrId;
      if (hfrId && abhaAddress?.trim()?.length > 0) {
        requestPayload["preferred_abha_address"] = abhaAddress?.trim();
        requestPayload["verify_abha_address"] = verifyAbhaAddress;
        requestPayload["abha_number"] = abhaNumber;
      }
    }

    requestPayload["is_walkin"] = selectedSlotObj.is_walkin;
    //  requestPayload

    if (
      hasResourceAccess ||
      (addBooking && selectedBookingType === "Laboratory") //added for abha token booking lab appointment
    ) {
      bookResourceAppointmentAPICall(requestPayload);
    } else {
      let consultationSettingsId =
        hasResourceAccess || addBooking
          ? [0, 1, 5, 6].indexOf(selectedResourceProcedure?.id) > -1
            ? selectedResourceProcedure?.id
            : null
          : [0, 1, 5, 6].indexOf(apiSelectedConsultation?.value) > -1
          ? apiSelectedConsultation?.value
          : null;
      let procedureSettingsId =
        hasResourceAccess || addBooking
          ? [0, 1, 5, 6].indexOf(selectedResourceProcedure?.id) === -1
            ? selectedResourceProcedure?.id
            : null
          : [0, 1, 5, 6].indexOf(apiSelectedConsultation?.value) === -1
          ? apiSelectedConsultation?.value
          : null;
      requestPayload["doctor_id"] = doctor_Id;
      requestPayload["procedure_settings_id"] = procedureSettingsId;
      requestPayload["consultation_settings_id"] = consultationSettingsId;
      requestPayload["start_time"] = allotedPremiumSlot?.startTime
        ? moment(allotedPremiumSlot?.startTime, "hh:mm A").format("HH:mm:ssZ")
        : "";
      requestPayload["end_time"] = allotedPremiumSlot?.endTime
        ? moment(allotedPremiumSlot?.endTime, "hh:mm A").format("HH:mm:ssZ")
        : null;

      bookAppointment(requestPayload);
    }
    if (selectedValue) {
      let updatePayLoad = {
        user_id: userType === "staff" ? staffId : userId,
        user_type: localStorage.getItem("user_type"),
        patient_account_id: patientDetails.patient_account_id,
        patient_id: patientDetails.patient_id,
        patient_dob: data.dob
          ? moment(data.dob).format("YYYY-MM-DD")
          : newDate != ""
          ? moment(newDate).format("YYYY-MM-DD") //newDate
          : "", //data.dob && moment(data.dob).format("YYYY-MM-DD"),
        patient_email: patientDetails ? patientDetails?.patient_email : email,
        patient_gender: patientDetails.patient_gender,
        patient_name: data.patient_name,
        preferred_abha_address: abhaAddress,
        formatted_uhid: patientDetails?.formatted_uhid,
        abha_number: abhaPatientDetails?.health_id_number,
      };
      updatePatientDetails(updatePayLoad);
    }
  }
  const onSubmit = async (data) => {
    handleOnSubmit(data);
  };
  const handleOnSubmit = (data) => {
    if (abhaAddress) {
      if (!patientDetails?.dob && !patientDetails?.patient_dob) {
        setShowAbhaError("Please Enter Date of Birth.");
        return;
      } else {
        setShowAbhaError("");
      }
    } else {
      setShowAbhaError("");
    }
    if (
      patientDetails?.patient_email &&
      !EMAIL_REGEX.test(patientDetails?.patient_email)
    ) {
      let curr = emailRef?.current?.focus();
      return;
    }

    if (selectedValue) {
      let err = { ...errors };
      if (patientDetails?.patient_dob) {
        patientDetails["patient_dob"] = moment(
          patientDetails.patient_dob
        ).format("YYYY-MM-DD");
      }
      if (
        (!age && !patientDetails.age && !patientDetails.patient_dob) ||
        err.age
      ) {
        err = { ...err, age: "Please enter the age." };
      } else {
        err = { ...err, age: "" };
      }
      if (appointmentType !== "in-clinic" && !patientDetails?.patient_address) {
        err = { ...err, patient_address: "Please enter address" };
      } else {
        err = { ...err, patient_address: "" };
      }
      if (appointmentType === "in-clinic" && pincodeError) {
        err = { ...err, pincode: "Please enter valid pincode" };
      }
      if (!patientDetails?.patient_name) {
        err = { ...err, patient_name: "Please enter patient name" };
      }

      if (patientDetails.formatted_uhid) {
        validateUhid(patientDetails.formatted_uhid);
        if (errors?.formatted_uhid) {
          setTimeout(() => {
            inputRef.current.focus();
          }, 100);
        }
      }

      if (showGuardianDetails) {
        setRelationCode(patientDetails?.patient_relation_id);
        if (!patientDetails?.parent_guardian_name) {
          err = {
            ...err,
            parent_guardian_name: "Please enter parent or guardian name",
          };
        } else {
          setRelationName(patientDetails?.parent_guardian_name);
        }
      }
      setErrors({ ...err });
      if (
        Object.values(err).some((val) => val !== "") ||
        !patientDetails?.patient_state_name ||
        (!patientDetails?.patient_pincode && !pinCode)
      ) {
        if (!patientDetails?.patient_state_name) {
          setSelectedState(true);
        }
        if (
          (!patientDetails?.patient_pincode && !pinCode) ||
          !patientDetails?.patient_state_name
        ) {
          setPincodeError(true);
        }
        return;
      }
      savePatientDetails(patientDetails);
    } else {
      let err = { ...errors };
      if (patientDetails.formatted_uhid) {
        setTimeout(() => {
          if (inputRef) inputRef.current && inputRef.current.focus();
        }, 100);
        validateUhid(patientDetails.formatted_uhid);
      }
      if (!patientDetails?.patient_name) {
        err = { ...err, patient_name: "Please enter patient name." };
      } else {
        err = { ...err, patient_name: "" };
      }
      if (!patientDetails?.patient_gender) {
        err = { ...err, patient_gender: "Please select gender." };
      } else {
        err = { ...err, patient_gender: "" };
      }
      if (
        (!age && !patientDetails.age && !patientDetails.patient_dob) ||
        err.age
      ) {
        err = { ...err, age: "Please enter the age." };
      } else {
        err = { ...err, age: "" };
      }
      if (
        !patientDetails?.patient_no ||
        patientDetails?.patient_no.length < 10
      ) {
        err = { ...err, patient_no: "Please enter mobile number." };
      } else {
        err = { ...err, patient_no: "" };
      }
      if (appointmentType !== "in-clinic" && !patientDetails?.patient_address) {
        err = { ...err, patient_address: "Please enter address" };
      } else {
        err = { ...err, patient_address: "" };
      }
      if (showGuardianDetails) {
        if (!patientDetails?.parent_guardian_name) {
          err = {
            ...err,
            parent_guardian_name: "Please enter parent or guardian name",
          };
        }
      }
      setErrors({ ...err });
      if (
        Object.values(err).some((val) => val !== "") ||
        !patientDetails?.patient_state_name ||
        (!patientDetails?.patient_pincode && !pinCode)
      ) {
        if (!patientDetails?.patient_state_name) {
          setSelectedState(true);
        }
        if (!patientDetails?.patient_pincode && !pinCode) {
          setPincodeError(true);
        }
        return;
      }
      addNewPatient(patientDetails);
    }
  };
  function addNewPatient(data) {
    setLoading(true);
    let addNewRequestPayload = {
      phone_no: data?.patient_no?.includes("+91")
        ? data?.patient_no
        : data?.patient_no
        ? data?.patient_no.replace(/^/, "+91")
        : patientNumber,
    };
    addNewPatientApi(addNewRequestPayload, data);
  }

  const handleScannedData = (result) => {
    if (result) {
      C2CConsole.log(result);
      let data = null;
      try {
        data = JSON.parse(result);
      } catch (error) {
        C2CConsole.error(error);
      }

      if (data && data?.hidn && data?.hid) {
        if (data) {
          data["gender"] = getAbhaGender(data["gender"]);
          let dateFormats = [
            "DD/MM/YYYY",
            "DD-MM-YYYY",
            "YYYY-MM-DD",
            "YYYY/MM/DD",
            "MM/DD/YYYY",
            "MM-DD-YYYY",
          ];
          data["dob"] = moment(data["dob"], dateFormats).format("DD/MM/YYYY");
        }
        setQrCodeData(data);
        setInvalidQrCode(false);
        lastResult.current = null;
      } else {
        setQrCodeData("");
        setInvalidQrCode(true);
      }
    }
  };
  const handleNew = (val) => {
    if (val.keyCode === 13) {
      setSelectedValue(false);
      if (val.target.value) {
        const id = patientList.filter(
          (obj) => obj.patient_name === val.target.value
        );

        if (id.length === 0) {
          setShowName(false);
          setPatientDetails({
            ...patientDetails,
            patient_name: val.target.value,
          });
        }
      }
    }
  };
  const handleAbhaAddress = (e) => {
    if (!e.target?.value) {
      setShowAbhaError("");
    }
    setAbhaAddress(e.target.value);
    setAbhaNumber("");
  };

  const handleReferealName = (ele) => {
    setReferrelName(ele.target.value);

    setPatientDetails({
      ...patientDetails,
      referred_name: ele.target.value,
    });
  };

  const handleAllowNotificationsToggle = () => {
    setAllowNotifications(!allowNotifications);
  };

  const onReadResult = (result) => {
    if (!result) return;

    if (lastResult.current === result.text) {
      return;
    }

    lastResult.current = result.text;
    handleScannedData(lastResult.current);
  };

  const handleAbhaScan = () => {
    setInvalidQrCode(false);
    setQrCodeData("");
    setShowAbhaScan(true);
  };

  const handleAadharAbhaVerification = () => {
    setShowAadharAbhaVerification(!showAadharAbhaVerification);
  };

  function handleOnChange(evt) {
    const propertyName = evt.target.name;
    const propertyValue = evt.target.value;

    let details = { ...patientDetails };
    if (evt.target.name === "patient_gender") {
      clearErrors("patient_gender");
    }
    if (evt.target.name === "patient_email") {
      setEmail(evt.target.value);
    }
    if (evt.target.name === "patient_address") {
      setAddress(evt.target.value);
    }

    if (propertyName === "patient_pincode") {
      if (propertyValue?.length <= 6) {
        setPinCode(propertyValue);

        if (propertyValue.match(PINCODE_REGEX)) {
          if (appointmentType === "in-clinic") {
            getStateCity(propertyValue);
          } else {
            details["patient_pincode"] = propertyValue;
            setPincodeError(false);
          }
        } else {
          setPincodeError(true);
          setStateCity(null);
          details["patient_state_name"] = "";
          details["city_name"] = "";
        }
      }
    }
    if (propertyName === "parent_guardian_name") {
      propertyValue?.length >= 3 &&
        setErrors((prevErrors) => ({
          ...prevErrors,
          parent_guardian_name: "",
        }));
      setRelationName(propertyValue);
    }
    details[propertyName] = propertyValue;

    setPatientDetails({ ...details });

    // }
  }

  const getAgeToDisplay = (date) => {
    let startDate = moment(date, "YYYY-MM-DD");
    let endDate = moment();
    const duration = moment.duration(endDate.diff(startDate));
    return (
      `${duration.years() != "0" ? duration.years() + " Years " : ""}` +
      `${duration.years() < "10" ? duration.months() + " Months " : ""}` +
      `${duration.years() < "1" ? duration.days() + " Days " : ""}`
    );
  };

  const handleAge = (year, month, day) => {
    if (year != "" && month != "" && day != "") {
      let yy = Number(year),
        mm = Number(month),
        dd = Number(day);
      if (yy > 0 || mm > 0 || dd > 0) {
        let patientAge = "";
        if (!isNaN(yy)) {
          patientAge += year + " years ";
          setDyear(year);
        } else {
          patientAge += "00 years ";
        }
        if (!isNaN(mm)) {
          patientAge += month + " months ";
          setDmonth(month);
        } else {
          patientAge += "00 months ";
        }
        if (!isNaN(dd)) {
          patientAge += day + " days ";
          setDday(day);
        } else {
          patientAge += "00 days ";
        }
        setAge(patientAge);
        setValue("age", patientAge);
        clearErrors("age");
      } else {
        setValue("age", null);
        setErrors((prevErrors) => ({
          ...prevErrors,
          age: "Please enter the age.",
        }));
      }
    } else {
      setValue("age", null);
      setErrors((prevErrors) => ({
        ...prevErrors,
        age: "Please enter the age.",
      }));
    }
  };

  const calcTotalFileSize = (uploadedDocs) => {
    let totalFileSize = 0;
    uploadedDocs.forEach((doc) => {
      totalFileSize = totalFileSize + Number(doc.size);
    });
    return totalFileSize;
  };

  const handleReferredBySelect = (ele) => {
    let obj = ele
      ? {
          label: ele.label,
          value: ele.value,
          doctor_id: ele.doctor_id,
        }
      : "";

    setReferredBy(obj);
    setPatientDetails({
      ...patientDetails,
      referred_by: ele?.value,
    });
    setReferrelName("");
  };

  const handleSelect = (value) => {
    setSelectedState(false);

    setPatientDetails({
      ...patientDetails,
      patient_state_code: value.value,
      patient_state_name: value.label,
    });
  };

  const getAbhaDobFormat = () => {
    let dateFormats = [
      "DD/MM/YYYY",
      "DD-MM-YYYY",
      "YYYY-MM-DD",
      "YYYY/MM/DD",
      "MM/DD/YYYY",
      "MM-DD-YYYY",
    ];
    return moment(abhaPatientDetails?.dob, dateFormats).format("DD/MM/YYYY");
  };

  const handleSubmitAbhaPatientDetails = () => {
    handleCloseAbhaConfirmationContent();
    let dateFormats = [
      "DD/MM/YYYY",
      "DD-MM-YYYY",
      "YYYY-MM-DD",
      "YYYY/MM/DD",
      "MM/DD/YYYY",
      "MM-DD-YYYY",
    ];
    let qrDob = moment(abhaPatientDetails?.dob, dateFormats).format(
      "YYYY-MM-DD"
    );
    setNoDob(false);
    setNewDate(qrDob);
    getAge(qrDob);
    patientDetails.dob = qrDob;
    patientDetails.patient_name = abhaPatientDetails?.name;
    patientDetails.patient_gender = abhaPatientDetails?.gender;
    patientDetails.patient_address = abhaPatientDetails?.address;
    setAbhaAddress(abhaPatientDetails?.abha_address);
    setAbhaNumber(abhaPatientDetails?.ABHANumber);
    setPatientDetails({ ...patientDetails });
  };

  const handleSubmitExistingPatientDetails = () => {
    setAbhaAddress(abhaPatientDetails?.abha_address);
    setAbhaNumber(abhaPatientDetails?.ABHANumber);
    handleCloseAbhaConfirmationContent();
  };

  const handleRetryBtn = () => {
    setInvalidQrCode(false);
    setQrCodeData("");
  };

  const handleCancelConfirmation = () => {
    setAbhaAddress(qrCodedata?.hid?.replace("@sbx", "")?.replace("@abdm", ""));
    setShowAbhaScan(false);
  };

  const getConfirmationDob = () => {
    let confirmationDob = "";
    if (patientDetails?.dob) {
      confirmationDob = moment(patientDetails?.dob).format("DD/MM/YYYY");
    } else if (newDate !== "") {
      confirmationDob = moment(newDate).format("DD/MM/YYYY");
    }

    return confirmationDob;
  };

  const handleConfirmQrCodeData = () => {
    setAbhaAddress(qrCodedata?.hid?.replace("@sbx", "")?.replace("@abdm", ""));

    let dateFormats = [
      "DD/MM/YYYY",
      "DD-MM-YYYY",
      "YYYY-MM-DD",
      "YYYY/MM/DD",
      "MM/DD/YYYY",
      "MM-DD-YYYY",
    ];
    let qrDob = moment(qrCodedata?.dob, dateFormats).format("YYYY-MM-DD");
    setNoDob(false);
    setNewDate(qrDob);
    getAge(qrDob);
    patientDetails.dob = qrDob;
    patientDetails.patient_name = qrCodedata?.name;
    patientDetails.patient_gender = qrCodedata?.gender;
    patientDetails.patient_address = qrCodedata?.address;
    if (!patientDetails?.patient_no) {
      patientDetails.patient_no = qrCodedata?.mobile;
      setWhatsAppNumber(qrCodedata?.mobile);
    }
    setPatientDetails({ ...patientDetails });
    setShowAbhaScan(false);
  };

  const handlePopulateAbhaDetails = (abhaDetails) => {
    setPatientDetails({
      ...patientDetails,
      patient_name: abhaDetails?.name,
      patient_gender: abhaDetails?.gender,
      patient_address: abhaDetails?.address,
    });
    let templAbhaAddress = abhaDetails?.preferred_abha_address
      ? abhaDetails?.preferred_abha_address?.split("@")[0]
      : "";
    setAbhaAddress(templAbhaAddress);
    let parts = abhaDetails?.dob?.split("-");
    let day = parseInt(parts[0], 10);
    let month = parseInt(parts[1], 10);
    let year = parseInt(parts[2], 10);

    let formattedDay = day < 10 ? "0" + day : day;
    let formattedMonth = month < 10 ? "0" + month : month;
    let dateObj = {
      day: formattedDay,
      month: formattedMonth,
      year: year,
    };
    getUserDOB(dateObj, false);
    setShowAadharAbhaVerification(false);
    if (abhaDetails?.pinCode) {
      getStateCity(abhaDetails?.pinCode);
      setPinCode(abhaDetails?.pincode);
    }
    setAbhaNumber(abhaDetails?.ABHANumber);
  };
  const handlePopulateAbhaAddress = (abhaAddress, abhaNumber) => {
    let templAbhaAddress = abhaAddress ? abhaAddress?.split("@")[0] : "";
    setAbhaAddress(templAbhaAddress);
    setAbhaNumber(abhaNumber);
    setShowAadharAbhaVerification(false);
  };

  // Create UI ===>

  const createSaveAndContinueUI = () => {
    const isButtonDisabled =
      referredBy?.label === "Other" || referredBy?.label === "Organization"
        ? !patientDetails["referred_name"] ||
          patientDetails["referred_name"]?.length === 0
        : false;

    return (
      <div className="mt-4">
        <button
          className="btn primary-cta-button rounded-pill py-2 px-4 button-style"
          disabled={isButtonDisabled}
          onClick={() => onSubmit(patientDetails)}
        >
          Save &amp; Continue
        </button>
      </div>
    );
  };
  const createRelationUI = () => {
    return (
      <div className="col-lg-6 col-12 patient-form-item ">
        <label htmlFor="reactrelation">Select Relation (Optional)</label>
        <>
          <Select
            className="select_style"
            onChange={(value) => {
              handleRelationSelect(value);
            }}
            styles={reationStyles}
            placeholder="Select Relation"
            options={relationList}
            name={"patient_relation_id"}
            isDisabled={selectedRelationValue}
            value={relationList.filter((option) => {
              return (
                option?.label?.toLowerCase() ===
                patientDetails?.relation?.toLowerCase()
              );
            })}
            components={{ DropdownIndicator }}
          />
          <p className="pl-1 pt-1 error"> &nbsp;</p>
        </>
      </div>
    );
  };
  const createPatientGuardianUI = () => {
    return (
      (showGuardianDetails || patientDetails?.parent_guardian_name) && (
        <div className="col-lg-6 col-12 patient-form-item">
          <label className="required" htmlFor="parent_guardian_name">
            Parent / Guardian Name
          </label>
          <input
            type="text"
            name="parent_guardian_name"
            onChange={handleOnChange}
            value={patientDetails?.parent_guardian_name}
            disabled={selectedGuardianValue}
          />
          {errors.parent_guardian_name ? (
            <p className="pl-1 pt-1 error">
              Please enter parent or guardian name
            </p>
          ) : (
            <p className="pl-1 pt-1 error"> &nbsp;</p>
          )}
        </div>
      )
    );
  };
  const createSelectPatientUI = () => {
    return (
      clinicId &&
      isUHidEnabled && (
        <div className="col-lg-6 col-12 patient-form-item">
          <label htmlFor="uhid">UHID</label>
          <SearchPatientComponent
            searchedPatientCallback={getSearchedPatient}
            className="select_style"
            inputType="text"
            placeholderText="Search With UHID"
            styles={reationStyles}
            showName={false}
            doctor_id={doctorData?.doctor_id} // Pass the doctor ID prop here
            values={patientDetails?.formatted_uhid}
            removePatientName={removePatientName}
            setRemovePatientName={setRemovePatientName}
            closeData={removeUHID}
            handleInputChange={(e) => {
              handleInputChange(e, "formatted_uhid");
            }}
            getList={getList}
            handleDisablePatientName={handleDisablePatientName}
            name="formatted_uhid"
            newPatient={false}
            hasError={isInvalidUHID}
            required={false}
            setPatientAccountId={setPatientAccountId}
            appointmentType={appointmentType}
            disable={patientDetails?.manual_uhid?.toLowerCase() === "false"}
          />
          {errors.formatted_uhid ? (
            <p className="pl-1 pt-1 error-uhid">
              {errors?.formatted_uhid?.message}
            </p>
          ) : (
            <p className="pl-1 pt-1 error"> &nbsp;</p>
          )}
        </div>
      )
    );
  };

  const createPatientNameUI = () => {
    return (
      <div className="col-lg-6 col-12 patient-form-item">
        <label className="required" htmlFor="patientName">
          Patient Name
        </label>
        {showName ? (
          <CreatableSelect
            className="select_style custom_select"
            onChange={(value) => {
              handlePatientSelect(value);
            }}
            onBlur={(value) => {
              handleNewPatientName(value);
            }}
            onKeyDown={(value) => {
              handleNew(value);
            }}
            styles={reationStyles}
            placeholder="Select Patient"
            options={patientList}
            autoFocus={patientNameAutoFocus}
            name={"patient_name"}
            ref={patientDropdownRef}
            formatCreateLabel={() => "No data found"}
            components={{ DropdownIndicator }}
          />
        ) : (
          <SearchPatientComponent
            searchedPatientCallback={getSearchedPatient}
            className="select_style"
            inputType="text"
            placeholderText="Select Name"
            styles={reationStyles}
            showName={showName}
            doctor_id={doctorData?.doctor_id}
            values={patientDetails?.patient_name}
            removePatientName={removePatientName}
            setRemovePatientName={setRemovePatientName}
            closeData={removePatientNameData}
            handleInputChange={(e) => {
              handleInputChange(e, "name");
            }}
            getList={getList}
            inputRef={patientDropdownRef}
            handleDisablePatientName={handleDisablePatientName}
            name="patient_name"
            disable={patientNameSelect || isAbhaDetails}
            newPatient={newPatient}
            required={true}
            setPatientAccountId={setPatientAccountId}
            appointmentType={appointmentType}
          />
        )}
        {errors.patient_name ? (
          <p className="pl-1 pt-1 error">Please enter patient name.</p>
        ) : (
          <p className="pl-1 pt-1 error"> &nbsp;</p>
        )}
      </div>
    );
  };
  const createEmailUI = () => {
    return (
      <div className="col-lg-6 patient-form-item">
        <label htmlFor="email">Email</label>
        <input
          type="text"
          name="patient_email"
          ref={emailRef}
          value={patientDetails ? patientDetails.patient_email : email}
          onChange={handleOnChange}
        />
        {errors.email ? (
          <p className="pl-1 pt-1 error">Please enter valid email.</p>
        ) : (
          <p className="pl-1 pt-1 error"> &nbsp;</p>
        )}
      </div>
    );
  };
  const GenderSelection = ({ options, selectedOption, onChange }) => {
    return (
      <>
        {options.map((option) => (
          <div className="form-check form-check-inline" key={option}>
            <input
              className="gender-form-check-input"
              type="radio"
              value={option}
              id={option}
              name="patient_gender"
              checked={selectedOption === option}
              onChange={onChange}
              disabled={isAbhaDetails}
            />
            <label htmlFor={option} className="mb-0">
              <span>{option}</span>
            </label>
          </div>
        ))}
      </>
    );
  };
  const createGenderUI = () => {
    return (
      <div className="col-lg-6 col-12 patient-form-item">
        <label className="required" htmlFor="sex">
          Gender
        </label>
        <div className="gender-options">
          <GenderSelection
            options={genderOptions}
            selectedOption={patientDetails?.patient_gender}
            onChange={handleOnChange}
          />
        </div>
        {errors.patient_gender ? (
          <p className="pl-1 pt-1 error">Please select gender.</p>
        ) : (
          <p className="pl-1 pt-1 error"> &nbsp;</p>
        )}
      </div>
    );
  };

  const renderDateOfBirth = () => {
    return newDate !== "" && !noDob ? (
      moment(newDate).format("DD MMM YYYY")
    ) : (
      <CustomeDatePicker
        selectedDate={dropdownSelectedDate}
        get_selected_Date={(userDOB, errorStatus) => {
          getUserDOB(userDOB, errorStatus);
        }}
      />
    );
  };
  const createDOBUI = () => {
    return (
      <div className="row">
        <div className="col-lg-6 col-12 patient-form-item d-flex justify-content-start">
          <label htmlFor="dob">Date of Birth</label>
          {renderDateOfBirth()}
          {errors.dob ? (
            <p className="pl-1 pt-1 error">
              Please choose a valid date of birth
            </p>
          ) : (
            <p className="pl-1 pt-1 error">&nbsp;</p>
          )}
        </div>
        <div className="col-lg-6 col-12 patient-form-item">
          <div className="d-flex">
            <label className="required" htmlFor="age">
              Age
            </label>
            <Popover
              isOpen={isOpen}
              preferPlace="below"
              place={null}
              className="pop-class"
              body={
                <p style={{ fontSize: "14px" }} className="m-0 p-2">
                  You have to add age for every booking. This details will not
                  be saved for the future booking unless DOB is entered.
                </p>
              }
            >
              <img
                src={Info}
                alt=""
                className="ml-2 age-info-icon"
                style={{ width: "16px", height: "16px" }}
                onMouseOver={() => setOpen(true)}
                onMouseOut={() => setOpen(false)}
              />
            </Popover>
          </div>
          {renderAge()}
          {errors.age ? (
            <p className="pl-1 pt-1 error">Please enter the age.</p>
          ) : (
            <p className="pl-1 pt-1 error">&nbsp;</p>
          )}
        </div>
      </div>
    );
  };
  const renderAge = () => {
    if (newDate !== "" && !noDob) {
      return <p className="m-0">{getAgeToDisplay(newDate)}</p>;
    } else {
      return (
        <DatePickerNew
          name={"age"}
          handleAge={handleAge}
          age={age}
          d_day={Number(d_day)}
          d_month={Number(d_month)}
          d_year={Number(d_year)}
          setDday={setDday}
          setDyear={setDyear}
          setDmonth={setDmonth}
          newDate={newDate}
          disableAge={disableAge}
        />
      );
    }
  };
  const createAbhaAddress = () => {
    return (
      <div className="row">
        <div className="col-12 patient-form-item">
          <label htmlFor="preferred_abha_address" style={{ textAlign: "left" }}>
            Enter ABHA Address or Scan Patients ABHA ID
          </label>
          <div className="pd-abha-address-input-container">
            <div className="pd-abha-input-container">
              <input
                className="pd-abha-input"
                type="text"
                name="preferred_abha_address"
                placeholder="Enter Your ABHA Address"
                value={abhaAddress}
                onChange={handleAbhaAddress}
                disabled={disableAbha || (abhaAddress && isAbhaDetails)}
              />
              <div className="pd-abha-input-suffix">
                {process.env.REACT_APP_ENV !== PROD ? "@sbx" : "@abdm"}
              </div>
            </div>
            <div className="pd-abha-text"></div>
            <div
              className="pd-abha-scan-qr-code-container"
              onClick={handleAbhaScan}
            >
              <img alt="" src={qrCodeSmall} />
              <div>Scan ABHA ID</div>
            </div>
            <div className="pd-abha-text"></div>
            <div
              className="pd-abha-scan-qr-code-container"
              onClick={handleAadharAbhaVerification}
            >
              <img alt="" src={abhaAdhaarIcon} />
              <div>Aadhar Number/ABHA Number</div>
            </div>
          </div>

          {showAbhaError && <p className="pl-1 pt-1 error">{showAbhaError}</p>}
        </div>
      </div>
    );
  };
  const createOnlineAddressUI = () => {
    return (
      <div className="col-12 patient-form-item">
        {appointmentType !== "in-clinic" ? (
          <>
            <label className="required" htmlFor="address">
              Address
            </label>
            <input
              type="text"
              name="patient_address"
              defaultValue={
                patientDetails ? patientDetails?.patient_address : address
              }
              onChange={handleOnChange}
              disabled={isAbhaDetails}
            />
            {errors?.patient_address ? (
              <p className="pl-1 pt-1 error">Please enter address.</p>
            ) : (
              ""
            )}
          </>
        ) : (
          createPinCodeUI()
        )}
      </div>
    );
  };
  const createInlineAddressUI = () => {
    return (
      appointmentType == "in-clinic" && (
        <div className="row">
          <div className="col-12 patient-form-item">
            <label className="" htmlFor="address">
              Address
            </label>
            <input
              type="text"
              name="patient_address"
              value={patientDetails ? patientDetails?.patient_address : address}
              onChange={handleOnChange}
              disabled={isAbhaDetails}
            />
          </div>
        </div>
      )
    );
  };
  const createInclincPincodeUI = () => {
    return (
      <div className="row">
        <div className="col-lg-6 col-12 patient-form-item">
          {appointmentType !== "in-clinic" ? (
            createPinCodeUI()
          ) : (
            <>
              <label htmlFor="city">City</label>
              <input
                className="city_input_val input-disabled"
                type="text"
                name="city"
                value={
                  stateCity?.city_name
                    ? stateCity?.city_name?.charAt(0)?.toUpperCase() +
                      "" +
                      stateCity?.city_name?.substr(1)?.toLowerCase()
                    : patientDetails?.city_name
                }
                disabled
              />
            </>
          )}
        </div>
        {createStateUI()}
      </div>
    );
  };
  const createReferenceUI = () => {
    return clinicId !== null ? (
      <div className="row" style={{ display: "flex", alignItems: "baseline" }}>
        <div className="col-lg-6 col-12 patient-form-item">
          {createReferredByUI()}
        </div>

        <div
          className="col-lg-6 col-12 patient-form-item referral_name_div"
          disabled={
            referredBy?.label === "Other" ||
            referredBy?.label === "Organization"
              ? false
              : true
          }
        >
          <label htmlFor="reactstate">Referral Name</label>
          <input
            type="text"
            name="referred_name"
            onChange={(e) => handleReferealName(e)}
            value={referrelName}
            maxLength={60}
          />
          <small className="referral_name_small_text">
            Choose Other Or Organization to Enable Referral Name
          </small>
        </div>
      </div>
    ) : null;
  };
  const createCustomOptions = ({ value, label, chipLabel }) => {
    return (
      <div>
        <div>{label}</div>
        <span
          id="doctor_specification"
          style={{ fontSize: 12, color: "#A3A9B7" }}
        >
          {chipLabel}
        </span>
      </div>
    );
  };
  const createNoteUI = () => {
    return (
      <div className="row">
        <div className="col-12 patient-form-item">
          <label htmlFor="note">Note (Purpose of Consultation)</label>
          <input
            type="text"
            name="note"
            value={patientDetails?.note}
            onChange={handleOnChange}
          />{" "}
        </div>
      </div>
    );
  };

  const createUploadUI = () => {
    return (
      <div className="row">
        <div className="col-12 patient-form-item">
          <label htmlFor="note">Upload Documents</label>
          <p style={{ textAlign: "start" }}>
            Upload any previous medical transcripts, test results, diagnostic
            reports.
          </p>
          <div className="upload-docs">
            <MultipleFileSelector
              showWarning
              maxTotalCap={50}
              maxFileSize={20}
              retainFileState={retainFileState}
              handleFileState={handleFileState}
              selectedImages={(imageArray) => {
                if (calcTotalFileSize(imageArray) < 50)
                  setUploadedDocs(imageArray);
              }}
              styles={{
                display: "grid",
                gap: "1rem",
                gridTemplateColumns: "repeat(auto-fill, minmax(140px, 2fr))",
                padding: "1rem",
                justifyContent: "center",
                marginTop: "2px",
                background: "#dae0e2",
              }}
              chooseFileText={"CHOOSE FILE"}
            />
          </div>
          {isDocUploaded && <Loader />}
        </div>
      </div>
    );
  };
  const createAllowNotificationUI = () => {
    return (
      <div className="row mt-3 ms-2" style={{ marginLeft: 3 }}>
        <div className=" whatsapp_div">
          <div className="d-flex align-items-center hover-pointer cursor-pointer">
            <label
              className={`whatsapp_checkbox hover-pointer cursor-pointer ${
                allowNotifications ? "selected" : "unselected"
              }`}
              style={{
                backgroundColor: allowNotifications ? "#17bae0" : "",
              }}
              onClick={handleAllowNotificationsToggle}
            >
              <span>
                {allowNotifications ? (
                  <i
                    className="fa fa-check facheck cursor-pointer"
                    style={{ fontSize: 13 }}
                  ></i>
                ) : null}
              </span>
            </label>
            <span className="fnt-14 whatsapp_ntfcn">
              Allow all notifications for this appointment
            </span>
          </div>
        </div>
      </div>
    );
  };

  const createReferredByUI = () => {
    return (
      <>
        <label htmlFor="reactstate">Referred By</label>
        <Select
          isClearable
          isSearchable
          options={referrelList}
          formatOptionLabel={createCustomOptions}
          placeholder=""
          onChange={(e) => handleReferredBySelect(e)}
          value={referredBy}
          defaultValue={appointmentType !== "in-clinic" && [STATE_LIST[15]]}
          styles={customStyles}
          name={"referred_by"}
          components={{
            DropdownIndicator: () => null,
            IndicatorSeparator: () => null,
          }}
        />
      </>
    );
  };
  const DropdownIndicator = (property) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...property}>
          {property.selectProps.menuIsOpen ? (
            <i className="fa fa-caret-up" style={{ color: "#17bae0" }}></i>
          ) : (
            <i className="fa fa-caret-down" style={{ color: "#17bae0" }}></i>
          )}
        </components.DropdownIndicator>
      )
    );
  };
  const createMobileUI = () => {
    return (
      <div className="col-lg-6 col-12 patient-form-item">
        <label className="required" htmlFor="mobileNumber">
          Mobile Number
        </label>
        <div class="input-group-prepend phone_width">
          <SearchPatientComponent
            searchedPatientCallback={getSearchedPatient}
            closeData={removeData}
            inputType="number"
            className="select_style"
            placeholderText="Mobile Number"
            name="patient_no"
            maxLengthValue="10"
            maxLengthCheck={maxLengthCheck}
            doctor_id={doctorData?.doctor_id}
            styles={reationStyles}
            values={patientDetails?.patient_no?.replace("+91", "")}
            removePatientName={removePatientName}
            setRemovePatientName={setRemovePatientName}
            getList={getList}
            ref={inputRef}
            handleDisablePatientName={handleDisablePatientName}
            disable={selectedPatientValue || isAbhaDetails}
            handleInputChange={(e) => {
              handleInputChange(e, "number");
            }}
            required={true}
            setPatientAccountId={setPatientAccountId}
            countryCode={true}
            appointmentType={appointmentType}
            isCloseIconVisible={true}
          />
        </div>
        {errors.patient_no ? (
          <p className="pl-1 pt-1 error">Please enter valid mobile number.</p>
        ) : (
          <p className="pl-1 pt-1 error"> &nbsp;</p>
        )}
      </div>
    );
  };
  const showWhatsAppNotifications = () => {
    return (
      <>
        {(enableWhatsaapNotification || !clinicId) && (
          <WhatsAppContainer
            whatsAppNumber={whatsAppNumber}
            setWhatsAppNumber={setWhatsAppNumber}
            whatsappMessageEnable={whatsappMessageEnable}
            setWhatsappMessageEnable={setWhatsappMessageEnable}
            height={40}
            clearErrors={clearErrors}
            outerError={errors?.whatsAppNumber}
            setShowTopMargin={setShowTopMargin}
          />
        )}
      </>
    );
  };
  const createWhatsAppUI = () => {
    return (
      <div
        className={`col-lg-6 col-12 patient-form-item ${
          showTopMargin ? "mt--11 mt-4" : "mt-20"
        } `}
      >
        {(patientDetails?.patient_no?.length === 10 ||
          patientDetails?.patient_no?.length === 13) && (
          <>{showWhatsAppNotifications()}</>
        )}
      </div>
    );
  };

  const createStateUI = () => {
    return (
      <div className="col-lg-6 col-12 patient-form-item">
        {appointmentType !== "in-clinic" ? (
          <>
            <label className="required" htmlFor="reactstate">
              State
            </label>

            <Select
              className="select_style"
              onChange={(value) => {
                handleSelect(value);
              }}
              options={STATE_LIST}
              placeholder=""
              value={STATE_LIST.filter((option) => {
                return (
                  option?.label?.toLowerCase() ===
                  patientDetails?.patient_state_name?.toLowerCase()
                );
              })}
              styles={customStyles}
              name={"patient_state_name"}
            />
            {selectedState ? (
              <p className="pl-1 pt-1 error">Please enter the state.</p>
            ) : (
              <p className="pl-1 pt-1 error"> &nbsp;</p>
            )}
          </>
        ) : (
          <>
            <label htmlFor="reactstate">State</label>
            <input
              className="city_input_val input-disabled"
              type="text"
              name="state"
              value={
                stateCity?.state_name
                  ? stateCity?.state_name
                  : patientDetails?.patient_state_name
              }
              disabled
            />
          </>
        )}
      </div>
    );
  };
  const createPinCodeUI = () => {
    return (
      <>
        <label className="required" htmlFor="pincode">
          Pincode
        </label>
        <input
          type="number"
          name="patient_pincode"
          maxlength="6"
          onKeyDown={(e) =>
            (e.keyCode === 69 ||
              e.keyCode === 187 ||
              e.keyCode === 61 ||
              e.keyCode === 190 ||
              e.keyCode === 189) &&
            e.preventDefault()
          }
          ref={pinCodeRef}
          onInput={() => {
            if (!pinCode) {
              const autoFilledPin = pinCodeRef.current.value;
              setPinCode(autoFilledPin);
              setPatientDetails({
                ...patientDetails,
                patient_pincode: autoFilledPin,
              });
            }
          }}
          onChange={handleOnChange}
          value={pinCode}
        />
        {pincodeError ? (
          <p className="pl-1 pt-1 error">Please enter valid pincode.</p>
        ) : (
          <p className="pl-1 pt-1 error"> &nbsp;</p>
        )}
      </>
    );
  };
  const displayAbhaDataConfirmation = () => {
    return (
      <>
        <div className="pd-abha-qr-data-confirmation">
          <div className="col-10 m-auto">
            <div className="pd-abha-qr-data-confirmation-title">
              Confirmation!
            </div>
            <div className="pd-abha-qr-data-confirmation-subtitle">
              Patient Details will be updated as per
              <br /> the ABHA Address{" "}
              <span style={{ fontWeight: "500" }}>
                “{abhaPatientDetails?.abha_address}”
              </span>
              . Do you want to continue ?
            </div>
            <div className="pd-abha-qr-data-confirmation-content-header">
              <div
                className="pd-abha-qr-data-confirmation-content-header-text"
                style={{
                  borderRight: "1px solid #E1E1E1",
                  textAlign: window.innerWidth > 768 ? "right" : "left",
                  paddingRight: window.innerWidth > 768 ? "70px" : "10px",
                }}
              >
                Existing Patient Details
              </div>
              <div
                className="pd-abha-qr-data-confirmation-content-header-text"
                style={{
                  textAlign: "left",
                  paddingLeft: window.innerWidth > 768 ? "70px" : "10px",
                }}
              >
                ABHA Patient Details
              </div>
            </div>
            <div className="pd-abha-qr-data-confirmation-content-body-container">
              <div
                className="pd-abha-qr-data-confirmation-content-body"
                style={{
                  borderRight: "1px solid #E1E1E1",
                  paddingLeft: window.innerWidth > 768 ? "11%" : "0",
                }}
              >
                {displayPatientDetails(
                  "Patient Name",
                  patientDetails?.patient_name
                )}
                {displayPatientDetails("Date of Birth", getConfirmationDob())}
                {displayPatientDetails(
                  "Gender",
                  patientDetails?.patient_gender
                )}
                {displayPatientDetails(
                  "Address",
                  patientDetails?.patient_address
                )}
                {displayPatientDetails(
                  "State",
                  patientDetails?.patient_state_name
                )}
              </div>
              <div
                className="pd-abha-qr-data-confirmation-content-body"
                style={{
                  paddingLeft: window.innerWidth > 768 ? "70px" : "10px",
                }}
              >
                {displayPatientDetails(
                  "Patient Name",
                  abhaPatientDetails?.name
                )}
                {displayPatientDetails("Date of Birth", getAbhaDobFormat())}
                {displayPatientDetails("Gender", abhaPatientDetails?.gender)}
                {displayPatientDetails("Address", abhaPatientDetails?.address)}
                {displayPatientDetails("State", abhaPatientDetails?.state_name)}
              </div>
            </div>
          </div>
        </div>
        <div className="pd-abha-qr-data-confirmation-footer-container">
          <div className="pd-abha-qr-data-confirmation-footer-left-btn">
            <SecondaryButton
              title="No"
              handleButtonClick={handleSubmitExistingPatientDetails}
            />
          </div>
          <div className="pd-abha-qr-data-confirmation-footer-right-btn">
            <PrimaryButton
              title="Yes"
              handleButtonClick={handleSubmitAbhaPatientDetails}
            />
          </div>
        </div>
      </>
    );
  };
  const displayPatientDetails = (title, value) => {
    return (
      value && (
        <div>
          <div className="pd-abha-qr-data-patient-details-title">{title}</div>
          <div className="pd-abha-qr-data-patient-details-value">{value}</div>
        </div>
      )
    );
  };
  const displayAbhaScan = () => {
    return (
      <div className={!invalidQrCode && qrCodedata ? "" : "col-10 m-auto"}>
        <div
          className={
            "pd-abha-scan-back-icon " +
            (!invalidQrCode && qrCodedata
              ? "pd-abha-scan-back-icon-confirmation-screen"
              : "")
          }
        >
          {!invalidQrCode && (
            <img alt="" src={backArrow} onClick={handleBackArrow} />
          )}
        </div>
        <div
          className="pd-abha-scan-container"
          style={{
            background:
              invalidQrCode || (!invalidQrCode && qrCodedata) ? "#fff" : "",
            marginTop: !invalidQrCode && qrCodedata ? "0" : "",
          }}
        >
          {!qrCodedata && !invalidQrCode && (
            <div className="pd-abha-scan-container-scan-icon">
              <img alt="" src={qrCodeBig} />
            </div>
          )}
          {!qrCodedata && !invalidQrCode && (
            <QrReader
              scanDelay={500}
              onResult={onReadResult}
              videoContainerStyle={{ height: "334px" }}
              videoStyle={{ height: "334px", maxWidth: "100%", zIndex: "2" }}
            />
          )}
          {invalidQrCode && displayInvalidQrCode()}
          {!invalidQrCode && qrCodedata && displayQrDataConfirmation()}
        </div>
      </div>
    );
  };

  const displayAadharAbhaVerification = () => {
    return (
      <div className="patient-abha-verification">
        <PatientAbhaVerification
          patientDetails={patientDetails}
          hfrId={hfrId}
          handleAadharAbhaVerification={handleAadharAbhaVerification}
          populateAbhaAddress={handlePopulateAbhaAddress}
          populateAbhaDetails={handlePopulateAbhaDetails}
        />
      </div>
    );
  };

  const displayQrDataConfirmation = () => {
    return (
      <>
        <div className="pd-abha-qr-data-confirmation">
          <div className="col-10 m-auto">
            <div className="pd-abha-qr-data-confirmation-title">
              Confirmation!
            </div>
            <div className="pd-abha-qr-data-confirmation-subtitle">
              Patient Details will be updated as per
              <br /> the ABHA Address{" "}
              <span style={{ fontWeight: "500" }}>“{qrCodedata?.hid}”</span>. Do
              you want to continue ?
            </div>
            <div className="pd-abha-qr-data-confirmation-content-header">
              <div
                className="pd-abha-qr-data-confirmation-content-header-text"
                style={{
                  borderRight: "1px solid #E1E1E1",
                  textAlign: window.innerWidth > 768 ? "right" : "left",
                  paddingRight: window.innerWidth > 768 ? "70px" : "10px",
                }}
              >
                Existing Patient Details
              </div>
              <div
                className="pd-abha-qr-data-confirmation-content-header-text"
                style={{
                  textAlign: "left",
                  paddingLeft: window.innerWidth > 768 ? "70px" : "10px",
                }}
              >
                ABHA Patient Details
              </div>
            </div>
            <div className="pd-abha-qr-data-confirmation-content-body-container">
              <div
                className="pd-abha-qr-data-confirmation-content-body"
                style={{
                  borderRight: "1px solid #E1E1E1",
                  paddingLeft: window.innerWidth > 768 ? "11%" : "0",
                }}
              >
                {displayPatientDetails(
                  "Patient Name",
                  patientDetails?.patient_name
                )}
                {displayPatientDetails("Date of Birth", getConfirmationDob())}
                {displayPatientDetails(
                  "Gender",
                  patientDetails?.patient_gender
                )}
                {displayPatientDetails(
                  "Address",
                  patientDetails?.patient_address
                )}
                {displayPatientDetails(
                  "State",
                  patientDetails?.patient_state_name
                )}
              </div>
              <div
                className="pd-abha-qr-data-confirmation-content-body"
                style={{
                  paddingLeft: window.innerWidth > 768 ? "70px" : "10px",
                }}
              >
                {displayPatientDetails("Patient Name", qrCodedata?.name)}
                {displayPatientDetails("Date of Birth", qrCodedata?.dob)}
                {displayPatientDetails("Gender", qrCodedata?.gender)}
                {displayPatientDetails("Address", qrCodedata?.address)}
                {displayPatientDetails("State", qrCodedata?.state_name)}
              </div>
            </div>
          </div>
        </div>
        <div className="pd-abha-qr-data-confirmation-footer-container">
          <div className="pd-abha-qr-data-confirmation-footer-left-btn">
            <SecondaryButton
              title="No"
              handleButtonClick={handleCancelConfirmation}
            />
          </div>
          <div className="pd-abha-qr-data-confirmation-footer-right-btn">
            <PrimaryButton
              title="Yes"
              handleButtonClick={handleConfirmQrCodeData}
            />
          </div>
        </div>
      </>
    );
  };
  const displayInvalidQrCode = () => {
    return (
      <div className="pd-abha-scan-invalid-qr-code-container">
        <div>
          <img
            alt=""
            src={errorIcon}
            className="pd-abha-scan-invalid-qr-code-error-icon"
          />
          <div className="pd-abha-scan-invalid-qr-code-text">
            The QR code was not scanned properly.
            <br /> Please try again.
          </div>
          <div className="d-flex justify-content-center">
            <PrimaryButton title="Retry" handleButtonClick={handleRetryBtn} />
          </div>
        </div>
      </div>
    );
  };
  // <===
  return (
    <div className="patient-details-form-container">
      {loading ? (
        <div className="text-center">
          <img src={require("../../../assets/C2C Loader.gif")} alt="" />
        </div>
      ) : (
        <>
          {showAbhaConfirmationPopup && displayAbhaDataConfirmation()}
          {showAbhaScan && displayAbhaScan()}{" "}
          {showAadharAbhaVerification && displayAadharAbhaVerification()}{" "}
          {!showAbhaConfirmationPopup &&
            !showAbhaScan &&
            !showAadharAbhaVerification && (
              <div className="appointment-steps-wrapper-sec">
                <section
                  className={
                    "col-10 m-auto " + (window.innerWidth > 768 ? "pr-0" : "")
                  }
                >
                  <div className="row mt-3 d-flex flex-lg-row flex-column align-items-start justify-content-start">
                    {createMobileUI()}
                    {createWhatsAppUI()}
                  </div>
                  <div className="row">
                    {createSelectPatientUI()}
                    {createPatientNameUI()}
                    {createRelationUI()}
                    {createPatientGuardianUI()}
                    {createEmailUI()}
                    {createGenderUI()}
                  </div>
                  {createDOBUI()}
                  {(process.env.REACT_APP_ENV === DEV ||
                    process.env.REACT_APP_ENV === QA ||
                    window.location.hostname === "localhost") && (
                    <>
                      {showAbhaAddress &&
                        appointmentType === "in-clinic" &&
                        createAbhaAddress()}
                    </>
                  )}
                  <div className="row">{createOnlineAddressUI()}</div>
                  {createInlineAddressUI()}
                  {createInclincPincodeUI()}
                  {createReferenceUI()}
                  {createNoteUI()}
                  {createUploadUI()}
                  {allowSmsNotification && createAllowNotificationUI()}
                  {createSaveAndContinueUI()}
                </section>
              </div>
            )}
        </>
      )}
    </div>
  );
};

export default PatientForm;
